import { render, staticRenderFns } from "./EventAdminStatistics.vue?vue&type=template&id=44963d16"
import script from "./EventAdminStatistics.vue?vue&type=script&lang=js"
export * from "./EventAdminStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports